"use client";

import {
	FeaturedText,
	type FeaturedTextProps
} from "@pamperedchef/design-system";

import * as styles from "./OfferHero.module.scss";

export interface OfferHeroProps {
	/** Hero's eyebrow */
	eyebrow?: string;
	/** Hero's headline */
	headline: string;
	/** Hero's headline style */
	headlineStyle?: FeaturedTextProps["styledAs"];
	/** Hero's theme */
	theme: FeaturedTextProps["theme"];
	/** Heading Tag */
	headlineTag?: FeaturedTextProps["headingTag"];
}

/**
 * Offer Hero
 */
export function OfferHero({
	eyebrow,
	headline,
	headlineStyle = "display-sm",
	theme,
	headlineTag = "h1"
}: OfferHeroProps): JSX.Element {
	return (
		<div className={styles["offer-hero"]}>
			<FeaturedText
				className={styles["title"]}
				eyebrow={eyebrow}
				headline={headline}
				styledAs={headlineStyle}
				theme={theme}
				headingTag={headlineTag}
			/>
		</div>
	);
}
